import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { FrontendLoggerService } from '@surface-elements/shared/util-logging';
import { VersionService } from '@surface-elements/shared/shared-util';
import { ShellComponent } from '@surface-elements/oms/feature-shell';
import { AlertContainerComponent } from '@surface-elements/shared/alert-system/ui';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [ShellComponent, AlertContainerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private readonly logger = inject(FrontendLoggerService);
  private readonly versionService = inject(VersionService);

  ngOnInit(): void {
    this.logger.info('OMS Application initialized', {
      version: this.versionService.getVersion(),
      environment: window.location.hostname,
    });

    this.logger.debug('Frontend logging service active', {
      features: ['console', 'localStorage', 'sensitiveDataSanitization'],
    });
  }
}
